import React from "react";
import "../../../../css/Common/Components/DesignSystem/Buttons.css";

// ButtonSmall is a small button component with a click effect.
// It toggles a 'clicked' state when pressed and calls the provided onClick handler.
class ButtonSmall extends React.Component {
  constructor() {
    super();

    // Initialize state for click effects
    this.state = {
      clicked: false,
      greenClicked: false, // Currently unused, can be used for additional styling
    };
  }

  render() {
    const { buttonText, onClick } = this.props;
    return (
      // Button-Small div toggles 'clicked' class on click
      <div
        className={`Button-Small ${this.state.clicked ? "clicked" : ""}`}
        onClick={() => {
          // Toggle clicked state for visual feedback
          this.setState({ clicked: !this.state.clicked });
          onClick(); // Call the onClick prop function
        }}
      >
        {/* Display the button text */}
        <div className="Button-Text">{buttonText}</div>
      </div>
    );
  }
}

export default ButtonSmall;
